import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import AttachmentsForm, {
  onAttachmentEvent,
  onAttachmentsTabSelected
} from "@/protected/components/AttachmentsForm";
import service from "./CustomerService";
import CustomerForm from "./CustomerForm";

const contextList = [
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.attachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      'ed <strong class="text-dark">ogni pratica</strong> ' +
      "collegate a questo " +
      '<strong class="text-primary">cliente</strong>.'
  },
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni richiesta</strong> ed ' +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questo " +
      '<strong class="text-primary">cliente</strong>.'
  }
];

export default {
  mixins: [AppEditorMixin],

  created() {
    this.tabs = [
      {
        component: CustomerForm,
        title: () => this.$t("customer.tabs.main"),
        icon: "user"
      },
      {
        id: "attachments",
        component: AttachmentsForm,
        title: () => this.$t("customer.tabs.attachments"),
        icon: "paperclip",
        show: !this.isNew,
        props: {
          contextList
        },
        events: {
          "attachment-event": onAttachmentEvent.bind(this)
        },
        tabSelected: onAttachmentsTabSelected.bind(this)
      }
    ];
  },

  methods: {
    getService() {
      return service;
    }
  }
};
